// extracted by mini-css-extract-plugin
export default {"content":"IdleStage_content__CLtaQ"};